import { render, staticRenderFns } from "./CollectionModal.vue?vue&type=template&id=3c41f60e&"
import script from "./CollectionModal.vue?vue&type=script&lang=js&"
export * from "./CollectionModal.vue?vue&type=script&lang=js&"
import style0 from "./CollectionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports